<div class="row">
	<div class="col-lg-6 col-md-6 col-sm-12">
		<h2>{{'nav.shipping_out' | translate}}</h2>
		<form #searchDeviceForm="ngForm" (ngSubmit)="getDevices()">
			<div class="mt-4">
				<div class="mt-3 input-group">
					<div class="form-check form-check-inline">
						<input
							class="form-check-input"
							type="radio"
							name="selectedDeviceFamily"
							[(ngModel)]="selectedDeviceFamily"
							id="deviceFamilyTelemetrics"
							[value]="DevicesFamily.TELEMETRICS"
							(change)="selectedShipmentDeviceFamilyChanged()"
							[disabled]="selectedDevices.length"
						>
						<label class="form-check-label" for="deviceFamilyTelemetrics">{{'g.telemetrics_family' | translate}}</label>
					</div>
					<div class="form-check form-check-inline">
						<input
						class="form-check-input"
						type="radio"
						name="selectedDeviceFamily"
						[(ngModel)]="selectedDeviceFamily"	id="deviceFamilyIotemeter"
						[value]="DevicesFamily.IOTEMETER"
						(change)="selectedShipmentDeviceFamilyChanged()"
						[disabled]="selectedDevices.length"
					>
						<label class="form-check-label" for="deviceFamilyIotemeter">{{'g.iotemeter_family' | translate}}</label>
					</div>
				</div>

				<!-- Skip Warnings Checkbox -->
				<div class="mt-3 form-check" *ngIf="selectedDeviceFamily === DevicesFamily.IOTEMETER">
					<input class="form-check-input" type="checkbox" id="skipWarningsChecks" (change)="skipWarningsChecks = !skipWarningsChecks" [disabled]="selectedDevices.length">
					<label class="form-check-label" for="skipWarningsChecks">{{'ready_to_ship.skip_warnings_check' | translate}}</label>
				</div>

				<div class="mb-2 mt-3">
					<ng-select
						name="po_number"
						[(ngModel)]="po_number"
						[items]="poNumbersDropdown"
						bindValue="value"
						bindLabel="label"
						placeholder="{{'ready_to_ship.po_number' | translate}}"
						[clearable]="false"
					></ng-select>
				</div>

				<small class="text-danger">{{'shipment.csv_file_rules_msg' | translate}}</small>
				<div *ngIf="selectedDeviceFamily === DevicesFamily.TELEMETRICS || skipWarningsChecks">
					<div class="custom-file my-2">
						<input type="file" class="custom-file-input" id="importFile" (change)="prepareMultiDevicesForShipment($event)" [disabled]="!showUploadFileEle">
						<label class="custom-file-label" #labelImport for="importFile">{{'shipment.import_devices_csv' | translate}}</label>
					</div>
					{{ 'g.or_capital' | translate }}
				</div>

				<div class="my-2">
					<input name="searchString" [(ngModel)]="searchString" trim-text placeholder="{{'g.serial_number' | translate}}/{{'g.mac_address' | translate}}" class="form-control" required/>
				</div>
				<div class="mt-3 input-group">
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="searchBy" [(ngModel)]="searchBy" id="searchByRadioSn" value="sn">
						<label class="form-check-label" for="searchByRadioSn">{{'g.serial_number' | translate}}</label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="searchBy" [(ngModel)]="searchBy" id="searchByRadioMac" value="mac">
						<label class="form-check-label" for="searchByRadioMac">{{'g.mac_address' | translate}}</label>
					</div>
				</div>
				<div class="mt-3">
					<button type="submit" class="btn btn-primary pointer" [disabled]="searchDeviceForm.invalid">{{'g.search' | translate}}</button>
				</div>
			</div>
		</form>
		<div class="col-md-6 my-5" *ngIf="searchResult?.length == 0 && !bulkSearchNotFoundDevices?.length">
			<b>{{'g.no_results_found' | translate}}</b>
		</div>
		<div class="col-md-12 my-5" *ngIf="!searchResult?.length && bulkSearchNotFoundDevices?.length">
			<b>{{'shipment.field_import_csv_devices_not_found' | translate}}</b>
			<ul>
				<li *ngFor="let device of bulkSearchNotFoundDevices">{{ device }}</li>
			</ul>
		</div>
		<div class="col-md-12 my-5" *ngIf="searchResult?.length > 0">
			<h3>{{'g.results' | translate}}:</h3>
			<div class="row py-2">
				<div class="col-md-3"><strong>{{'g.mac_address' | translate}}</strong></div>
				<div class="col-md-3"><strong>{{'g.serial_number' | translate}}</strong></div>
				<div class="col-md-6"><strong>{{'ready_to_ship.move_to_bulk' | translate}}</strong></div>
			</div>
			<div *ngFor="let device of searchResult" class="row py-2">
				<div class="col-md-3">
					<a
						[routerLink]="['/', sites[device.site_id]?.customer_id, device.site_id, device.mac_address, 'performance']"
						class="blue-hover pointer ml-1"
						target="_blank"
					>
						{{device.mac_address}}
					</a>
				</div>
				<div class="col-md-3">{{device.serial_number}}</div>
				<div class="col-md-6">
					<div *ngIf="device.is_sct_inventory && po_number">
						<fa-icon icon="arrow-right" size="lg" class="pointer" (click)="prepareForShipment(device, sites[device.site_id]?.customer_id)"></fa-icon>
					</div>
					<div *ngIf="!device.is_sct_inventory">
						<span class="text-danger">{{'common.device_not_sct_inventory' | translate}}</span>
					</div>
					<div *ngIf="!po_number">
						<span class="text-danger">{{'orders.select_po_number' | translate}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="col-lg-6 col-md-6 col-sm-12">
		<div class="d-flex justify-content-between">
			<h2>{{'ready_to_ship.to_be_updated' | translate}}</h2>
			<div>
				<a [routerLink]="['/management/shipment-history']"><button class="btn btn-primary btn-sm shipment-btn">{{'shipment.shipment_history' | translate}}</button></a>
			</div>
		</div>
		<div class="mt-3 input-group" *ngIf="selectedDeviceFamily === DevicesFamily.TELEMETRICS">
			<div class="form-check form-check-inline" *ngFor="let group of enterpriseGroups">
				<input class="form-check-input" type="radio" name="group" [(ngModel)]="selectedGroup" id="ent_{{group}}" value="{{group}}" (change)="onGroupChanged()">
				<label class="form-check-label" for="ent_{{group}}">{{enterpriseService.getGroupTypeText(group)}}</label>
			</div>
			<div class="ml-4 mr-2" [tooltip]="smartRebatesSelectedErr">
				<input class="form-check-input" type="radio" name="smart_rebates" id="smart_rebates" value="smart_rebates" [disabled]="disableSmartRebateOption" [(ngModel)]="selectedGroup" (change)="handleSmartRebatesGroup()">
				<label class="form-check-label" for="smart_rebates">{{'ready_to_ship.smart_rebates_option' |translate}}</label>
			</div>
			<div class="ml-4">
				<input class="form-check-input" type="radio" name="cbl" id="cbl" value="cbl" [(ngModel)]="selectedGroup" (change)="handleCBLGroup()">
				<label class="form-check-label" for="cbl">{{'ready_to_ship.cbl_option' |translate}}</label>
			</div>
		</div>

		<div class="col-md-6 my-5" *ngIf="selectedEnterpriseList?.length == 0">
			<b>{{'g.no_results_found' | translate}}</b>
		</div>

		<form (ngSubmit)="shipOutDevices()" validate-form="editSite" [innerModelGroups]="['site']">
			<div class="col-md-12 my-5" *ngIf="selectedEnterpriseList?.length > 0">
				<h3>{{'ready_to_ship.ship_to' | translate}}:</h3>
				<div class="row pt-2">
					<div class="col-md-6 pb-2">
						<ng-select
							name="enterprise_id"
							[(ngModel)]="shipOutToEnterprise"
							[items]="selectedEnterpriseList"
							bindValue="id"
							bindLabel="name"
							placeholder="{{'ent.select_enterprise' | translate}}"
							[clearable]="false"
							[disabled]= "smartRebatesGroup || cblGroup"
							(change)="onEnterpriseChanged()"
						></ng-select>
					</div>
					<div class="col-md-6 pb-2" *ngIf="selectedCustomerList?.length > 0">
						<ng-select
							name="customer_id"
							[(ngModel)]="shipOutToCustomer"
							[items]="selectedCustomerList"
							bindValue="id"
							bindLabel="name"
							placeholder="{{'customer.select_customer' | translate}}"
							[disabled]= "smartRebatesGroup || cblGroup"
							(change)="onCustomerChanged()"
						></ng-select>
					</div>
					<div class="col-md-6 pb-2" *ngIf="selectedSiteList?.length > 0">
						<ng-select
							name="site_id"
							[(ngModel)]="shipOutToSite"
							[items]="selectedSiteList"
							bindValue="id"
							bindLabel="name"
							[disabled]= "smartRebatesGroup || cblGroup || usePowerStudyDevicesSite"
							placeholder="{{'site.select_site' | translate}}"
						></ng-select>
					</div>
				</div>

				<!-- New Site -->
				<div class="my-2 align-items-center">
					<div class="col-md-2"></div>
					<div class="col-md-10">
						<fieldset *ngIf="shipOutToSite === 0">
							<legend><b>{{'g.site' | translate}}</b></legend>
							<app-site-edit [site]="site" [miniForm]="true" [customerEnterprises]="customerEnterprises" [enterpriseList]="selectedEnterpriseList" [showIotMeterOptions]="false"></app-site-edit>
							<app-mapbox-search
								class="border-radius main-blue-border"
								[latitude]="site.latitude||sitesService.defaultMapLocation.latitude"
								[longitude]="site.longitude||sitesService.defaultMapLocation.longitude"
								[zoom]="[3]"
								[zoomIn]="true"
								[showPopup]="false"
								[dots]="[{
									latitude: site.latitude||sitesService.defaultMapLocation.latitude,
									longitude: site.longitude||sitesService.defaultMapLocation.longitude
								}]"
								[clickEnabled]="true"
								(onAddressChanged)="updateSiteCoords($event)"
							></app-mapbox-search>
						</fieldset>
					</div>
				</div>
				<!-- New Site -->
				<div class="row">
					<div class="col-md-6 pb-2">
						<div class="row">
							<div class="col-md-12 d-flex">
								<div class="mr-2">
									<div class="w-100">
										<input type="file" [accept]="allowedUploadFilesExt.join(',')" id="actual-btn" name="files" multiple onclick="this.value=null;" (change)="selectFiles($event)" hidden>
										<label class="mb-0 btn btn-info d-flex justify-content-center" for="actual-btn">
											{{'ready_to_ship.attach_files' | translate}}
										</label>
									</div>
								</div>
								<button type="submit" class="btn btn-info" [disabled]="!shipOutToEnterprise || !shipOutToCustomer || (!shipOutToSite && shipOutToSite != 0) || selectedDevices.length == 0 || !po_number">
									{{(shipOutToSite === 0?'ready_to_ship.action_new_site':'ready_to_ship.action') | translate}}
								</button>
							</div>
						</div>
						<div class="row">
							<a *ngIf="selectedFiles.length" class="link-primary pointer" (click)="selectedFilesDialog.show();">
								<span class="d-flex justify-content-center">
									{{ "ready_to_ship.view_attached_files" | translate}}
								</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</form>
		<div class="col-md-12 my-5" *ngIf="selectedDevices.length > 0">
			<div class="row py-2">
				<div class="col-md-1"><strong>{{'g.number' | translate}}</strong></div>
				<div class="col-md-3"><strong>{{'g.mac_address' | translate}}</strong></div>
				<div class="col-md-3"><strong>{{'g.serial_number' | translate}}</strong></div>
				<div class="col-md-2" *ngIf="hasIotemeterEdgeDevices()"><strong>{{'g.configurations' | translate}}</strong></div>
				<div [ngClass]="hasIotemeterEdgeDevices() ? 'col-md-2' : 'col-md-3'"><strong>{{'g.remove' | translate}}</strong></div>
			</div>
			<div *ngFor="let device of selectedDevices; let i = index" class="row py-2">
				<div class="col-md-1">{{i +1}}</div>
				<div class="col-md-3"><a [routerLink]="['/', device._customer_id, device.site_id, device.mac_address, 'performance']" class="blue-hover pointer ml-1" target="_blank">{{device.mac_address}}</a></div>
				<div class="col-md-3">{{device.serial_number}}</div>
				<div class="col-md-2" *ngIf="hasIotemeterEdgeDevices()">
					<span *ngIf="isIotemeterEdgeDevice(device)">
						<fa-icon icon="edit" size="lg" class="pointer" [ngClass]="isDeviceConfigured(device) ? 'text-success' : 'text-warning'" (click)="openDeviceConfig(device)"></fa-icon>
					</span>
				</div>
				<div [ngClass]="hasIotemeterEdgeDevices() ? 'col-md-2' : 'col-md-3'">
					<fa-icon icon="window-close" size="2x" class="pointer text-danger" (click)="removeFromShipment(device)"></fa-icon>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal #selectedFilesDialog title="{{'ready_to_ship.selected_files' | translate}}" [hasConfirmButton]="false" [hasCloseButton]="false" [size]="'lg'">
	<div dialog-content>
		<div *ngIf="!selectedFiles else listOfFiles">
			{{'ready_to_ship.no_selected_files' | translate}}
		</div>
		<ng-template #listOfFiles>
			<sct-custom-table
				[columnsConfig]="columns"
				[data]="selectedFiles">
			</sct-custom-table>
		</ng-template>
	</div>
</app-modal>

<!-- Device Configuration Modal -->
<app-modal #deviceConfigModal title="{{'device.edit_device' | translate}}" [hasConfirmButton]="true" [confirmBtnText]="'g.save' | translate" [closeBtnText]="'g.cancel' | translate" [size]="'lg'">
	<div dialog-content>
		<div class="container">
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'g.code' | translate}}</strong></label>
				<div class="col-md-8">
					<ng-select
						[(ngModel)]="deviceConfigData.token"
						[items]="availableTokensList"
						bindValue="token"
						bindLabel="token"
						[clearable]="true"
						placeholder="{{'g.select' | translate}}"
						(change)="onTokenChanged($event)"
					></ng-select>
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'device.meter_number' | translate}}</strong> <span
						class="text-danger">*</span></label>
				<div class="col-md-8">
					<input type="number" class="form-control" [(ngModel)]="deviceConfigData.meter_number" [min]="0" [max]="maxMeterNumber"
						[disabled]="isTokenFieldDisabled()" placeholder="{{'device.meter_number' | translate}}">
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'warnings.panel_id' | translate}}</strong> <span
						class="text-danger">*</span></label>
				<div class="col-md-8">
					<input type="text" class="form-control" [(ngModel)]="deviceConfigData.power_view_sn" [disabled]="isTokenFieldDisabled()"
						placeholder="{{'warnings.panel_id' | translate}}">
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'device.feeder_meter' | translate}}</strong> <span
						class="text-danger">*</span></label>
				<div class="col-md-8">
					<ng-select
						[(ngModel)]="deviceConfigData.is_feeder_meter"
						[items]="feederMeterOptions"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
						[disabled]="isTokenFieldDisabled()"
						placeholder="{{'g.select' | translate}}"
					></ng-select>
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'ready_to_ship.accumulating_or_subtracting' | translate}}</strong>
					<span class="text-danger">*</span></label>
				<div class="col-md-8">
					<ng-select
						[(ngModel)]="deviceConfigData.is_meter_subtracting"
						[items]="accumulatingSubtractingOptions"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
						[disabled]="isTokenFieldDisabled()"
						placeholder="{{'g.select' | translate}}"
					></ng-select>
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'device.ct_ratio' | translate}}</strong> <span
						class="text-danger">*</span></label>
				<div class="col-md-8">
					<ng-select
						[(ngModel)]="deviceConfigData.ct_ratio"
						[items]="ctRatioOptions"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
						[disabled]="isTokenFieldDisabled()"
						placeholder="{{'g.select' | translate}}"
					></ng-select>
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'device.wiring_mode' | translate}}</strong> <span
						class="text-danger">*</span></label>
				<div class="col-md-8">
					<ng-select
						[(ngModel)]="deviceConfigData.wiring_mode"
						[items]="wiringModeOptions"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
						[disabled]="isTokenFieldDisabled()"
						placeholder="{{'g.select' | translate}}"
					></ng-select>
				</div>
			</div>
			<div class="form-group row mb-3">
				<div class="col-md-4"></div>
				<div class="col-md-8">
					<div class="form-check">
						<input class="form-check-input" type="checkbox" id="emptyNbiotBands" [(ngModel)]="deviceConfigData.empty_nbiot_bands" [disabled]="isTokenFieldDisabled()">
						<label class="form-check-label" for="emptyNbiotBands">{{'device.empty_iot_band' | translate}}</label>
					</div>
				</div>
			</div>
			<div class="form-group row mb-3">
				<label class="col-md-4 col-form-label"><strong>{{'device.nominal_voltage' | translate}}</strong> <span
						class="text-danger">*</span></label>
				<div class="col-md-8">
					<ng-select
						[(ngModel)]="deviceConfigData.nominal_voltage"
						[items]="nominalVoltageOptions"
						bindValue="value"
						bindLabel="label"
						[clearable]="false"
						[disabled]="isTokenFieldDisabled()"
						placeholder="{{'g.select' | translate}}"
					></ng-select>
					<small class="text-danger fw-bold">{{getNominalVoltageHint()}}</small>
				</div>
			</div>
		</div>
	</div>
</app-modal>
